import "./StepWrapper.scss";
import ProgressBar from "../ProgressBar";

const StepWrapper = ({ children, step, stepLabel, className }) => {
  return (
    <div className={`step__wrap ${className ? className : ""}`}>
      <ProgressBar step={step} />
      <span className="label">{stepLabel}</span>
      {children}
    </div>
  );
};
export default StepWrapper;
